/** SubViewportContainer registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseSubViewportContainer } from './parser';
const subViewportContainerRegistration = {
    typeName: 'SubViewportContainer',
    parser: parseSubViewportContainer,
};
nodeRegistry.register(subViewportContainerRegistration);
export * from './parser';
//# sourceMappingURL=index.js.map